import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VSnackbar,{attrs:{"color":_vm.snackColor,"timeout":_vm.snackTime,"bottom":"","right":""},model:{value:(_vm.snackState),callback:function ($$v) {_vm.snackState=$$v},expression:"snackState"}},[_vm._v(" "+_vm._s(_vm.statusMessage)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }